export const cleanProperty = (property?: string) =>
  property?.trim().toLowerCase().replace(/\s+/g, "");

export const replaceNBSP = (str: string) => {
  const regex = new RegExp(String.fromCharCode(160), "g");
  return str.replaceAll(regex, " ").replaceAll(/&nbsp;/g, " ");
};
